export const SubscriptionsType = {
  trial: 'trial',
  regular: 'regular',
  custom: 'custom',
} as const;

export const SubscriptionsStatus = {
  active: 'active',
  inactive: 'inactive',
} as const;
